import { Image, Button, Upload, UploadFile, UploadProps } from "antd";
import { useCallback, useState } from "react";
import ConfirmDelete from "../ConfirmDelete";
import { PopUp } from "../PopUp";
import { ErrorMessage } from "../Toasts/ErrorMessage";

type uploadProps = {
  imageUploaded?: string;
  loading: boolean;
  checklistFile: File | null;
  previewImage: {
    file: string;
    imagePreviewUrl: string | null;
  };
  setChecklistFile: React.Dispatch<React.SetStateAction<File | null>>;
  setPreviewImage: React.Dispatch<
    React.SetStateAction<{
      file: string;
      imagePreviewUrl: string | null;
    }>
  >;
  onImageDelete: () => void;

  uploadedImageURL?: string | undefined;
  saveUpload: () => void;
  modalPreviewImage: {
    file: string;
    imagePreviewUrl: string | null;
  };
  setModalPreviewImage: React.Dispatch<
    React.SetStateAction<{
      file: string;
      imagePreviewUrl: string | null;
    }>
  >;
  infoTextUploader?: string;
};

// type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

const UploadFull = (props: uploadProps) => {
  const {
    imageUploaded,
    loading,
    checklistFile,
    previewImage,
    setChecklistFile,
    setPreviewImage,
    onImageDelete,
    infoTextUploader = "A photo makes it easier for colleagues to recognize you. It’s optional",
  } = props;
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const onChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const deleteFunction = () => {
    if (onImageDelete) {
      onImageDelete();
    }
    setChecklistFile(null);
    setPreviewImage({
      file: "",
      imagePreviewUrl: null,
    });
    setConfirmDelete(false);
  };

  const confirmDeletePhoto = {
    visibility: confirmDelete,
    class: "upload_photo_modal",
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmDelete(false)}
        heading="Delete photo"
        paragraph="Delete your profile photo?"
        btnText="Delete photo"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setConfirmDelete(false),
  };

  const handleFileChange = useCallback(
    (file: File) => {
      setChecklistFile(file);
      const isIMG = file.type === "image/png" || file.type === "image/jpeg";
      if (!isIMG) {
        ErrorMessage(`${file.name} is not an image file`);
        // setFileTypeError(true);
      } else {
        // setFileTypeError(false);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage({
            file: file.name,
            imagePreviewUrl: reader.result as string,
          });
        };
        reader.readAsDataURL(file);
      }
      return isIMG || Upload.LIST_IGNORE;
    },
    [setChecklistFile, setPreviewImage]
  );

  return (
    <>
      <div className="service_picture_wrap">
        <div className="service_image">
          <Upload
            fileList={fileList}
            showUploadList={false}
            onChange={onChange}
            beforeUpload={handleFileChange}
            customRequest={() => null}
            maxCount={1}
            accept="image/png, image/jpeg"
          >
            <div className="upload_avatar">
              <Image
                src={
                  previewImage?.imagePreviewUrl || imageUploaded
                    ? previewImage?.imagePreviewUrl || imageUploaded
                    : "/images/upload/upload-icon.svg"
                }
                width={
                  previewImage?.imagePreviewUrl || imageUploaded ? "100%" : 24
                }
                height={
                  previewImage?.imagePreviewUrl || imageUploaded ? "100%" : 24
                }
                alt="Profile"
                preview={false}
              />
            </div>
          </Upload>
        </div>
        <div className="upload_btn_wrap">
          <Upload
            fileList={fileList}
            showUploadList={false}
            onChange={onChange}
            beforeUpload={handleFileChange}
            customRequest={() => null}
            maxCount={1}
            accept="image/png, image/jpeg"
          >
            <div className="upload_btn">
              <Button className="btn-sm" type="primary">
                {imageUploaded || checklistFile?.name
                  ? "Change picture"
                  : "Upload picture"}
              </Button>
              {(imageUploaded || checklistFile?.name) && (
                <Button
                  className="btn-sm"
                  type="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    setConfirmDelete(true);
                  }}
                >
                  Delete picture
                </Button>
              )}
            </div>
          </Upload>
          <p className="info_upload">{infoTextUploader}</p>
        </div>
      </div>

      <PopUp {...confirmDeletePhoto} />
    </>
  );
};

export default UploadFull;
